/**
 * WalkInCancelledPage.js (Phase 1 — 2026-09-25)
 *
 * Where Stripe sends a walk-in customer's browser when they tap the BACK arrow on the
 * Checkout page (that is the only thing that triggers `cancel_url` — closing the tab
 * or the session expiring does not).
 *
 * Why this page exists: `cancel_url` was set from the day the walk-in flow was built,
 * but no such route was ever registered, so the customer landed on a blank page.
 *
 * Deliberately INFORMATIONAL ONLY, with no action:
 *   - It does NOT call /cancel-pending-checkout. The desk may be about to re-send the
 *     link or take cash, and having the customer's browser silently delete the booking
 *     would pull the rug out from under them. The hold is short (5 minutes by default)
 *     and releases itself.
 *   - It does not report the booking's details either, because a cancel page is no
 *     place to leak an appointment summary to a shared or borrowed device.
 *
 * Styling reuses BookingConfirmation.css so it matches the sibling confirmation page.
 */

import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import CustomerHeader from "../../components/CustomerHeader";
import CustomerFooter from "../../components/CustomerFooter";
import "./BookingConfirmation.css";

function WalkInCancelledPage() {
  const [searchParams] = useSearchParams();
  // Present in the URL, deliberately not used for any action (see the header note).
  const hasBookingReference = Boolean(searchParams.get("booking_id"));

  return (
    <>
      <CustomerHeader />
      <div className="confirmation-container">
        <div className="confirmation-error">
          <div className="error-icon">⚠️</div>
          <h1>Payment not completed</h1>
          <p>
            Nothing has been charged. Your appointment is not confirmed yet — the time
            is only held briefly, and once it is released somebody else can take it.
          </p>
          <p>
            Please ask the desk to re-open the payment, or to take the payment another
            way.
          </p>
          {hasBookingReference ? (
            <p className="confirmation-note">
              Keep this page if you need to reference the booking — the desk can look it
              up from the reference in the address bar.
            </p>
          ) : null}
          <Link className="btn-primary" to="/">
            Done
          </Link>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default WalkInCancelledPage;
